// src/utils/api.js
import { msalConfig } from '../authConfig';

let _idToken = null;

// Called after MSAL login to store the ID token for API calls
export function setIdToken(token) {
  _idToken = token;
}

// Legacy no-op — kept so existing call sites don't break
export function setMsalContext() {}

export async function apiFetch(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(_idToken ? { 'X-ID-Token': _idToken } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(`/api/${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export function formatBytes(bytes) {
  if (!bytes) return '—';
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
}

export function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
}

export function timeUntil(iso) {
  const diff = new Date(iso) - new Date();
  if (diff <= 0) return 'Expired';
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(hours / 24);
  if (days > 0) return `${days}d ${hours % 24}h remaining`;
  return `${hours}h remaining`;
}

// A transfer/request the user (or an admin) deleted on purpose. Items purged automatically
// 30 days after expiry (deletedBy === 'auto') stay under Expired. Rows deleted before this
// was recorded have no deletedBy and are treated as manual.
export const isManuallyDeleted = t => t.status === 'deleted' && t.deletedBy !== 'auto';

export function deletedLabel(t, { admin = false } = {}) {
  const when = t.deletedAt ? ` ${formatDate(t.deletedAt)}` : '';
  if (t.deletedBy === 'auto') return `Automatically deleted${when} (30 days after expiry)`;
  if (t.deletedBy === 'admin') return `Deleted${when} by admin${t.deletedByName ? ` ${t.deletedByName}` : ''}`;
  if (t.deletedBy === 'owner') return admin && t.deletedByName ? `Deleted${when} by ${t.deletedByName}` : `Deleted${when} by you`;
  return `Deleted${when}`;
}
